import CommonModal from "@components/common/CommonModal";
import { checkFormChanges } from "@lib/checkFormChanges";
import { Checkbox, Form, Input } from "antd";
import { useEffect } from "react";
import { notify } from "../common/Notification";
import { SMSConfiguration } from "@/utils/types/smsConfiguration";

interface SMSConfigurationAddModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (data: SMSConfiguration) => void;
  initialData?: SMSConfiguration | null;
  isEditMode?: boolean;
  disabled?: boolean;
  confirmLoading?: boolean;
}

const SMSConfigurationAddModal: React.FC<SMSConfigurationAddModalProps> = ({
  open,
  onCancel,
  onSubmit,
  initialData,
  isEditMode = false,
  // disabled = false,
  confirmLoading = false,
}) => {
  const [form] = Form.useForm();
  // Data fetching queries
  // const { data: smsProviderOptions, isLoading: smsProviderLoading } = useQuery({
  //   queryKey: ["sms_provider"],
  //   queryFn: () => DropdownService.getDropdownData("sms_provider"),
  // });

  // const { data: smsApiKeyOptions, isLoading: smsApiKeyLoading } = useQuery({
  //   queryKey: ["sms_api_key"],
  //   queryFn: () => DropdownService.getDropdownData("sms_api_key"),
  // });

  // const { data: smsApiSecretOptions, isLoading: smsApiSecretLoading } = useQuery({
  //   queryKey: ["sms_api_secret"],
  //   queryFn: () => DropdownService.getDropdownData("sms_api_secret"),
  // });

  // const { data: smsApiUrlOptions, isLoading: smsApiUrlLoading } = useQuery({
  //   queryKey: ["sms_api_url"],
  //   queryFn: () => DropdownService.getDropdownData("sms_api_url"),
  // });

  // Reset form when modal opens/closes or initial data changes
  useEffect(() => {
    if (open) {
      if (initialData) {
        // Set form fields with initial data
        form.setFieldsValue({
          parameter: initialData.parameter,
          value: initialData.value,
          is_active: initialData.is_active,
          is_header: initialData.is_header,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, initialData, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (
        isEditMode &&
        initialData &&
        !checkFormChanges(values, initialData, notify)
      ) {
        return;
      }
      // Clean the data
      const data = {
        parameter: values.parameter,
        value: values.value,
        is_active: values.is_active,
        is_header: values.is_header,
      };

      onSubmit(data as unknown as SMSConfiguration);
      form.resetFields();
    } catch (error: any) {
      console.error("Failed to submit form:", error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  // Handle user selection change
  // const handleUserChange = (value: any) => {
  //   if (value) {
  //     form.setFieldsValue({ role_id: undefined });
  //   }
  // };

  // Handle role selection change
  // const handleRoleChange = (value: any) => {
  //   if (value) {
  //     form.setFieldsValue({ user_id: undefined });
  //   }
  // };

  return (
    <CommonModal
      title={isEditMode ? "Edit SMS Configuration" : "Add SMS Configuration"}
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      width={800}
      okText={isEditMode ? "Update" : "Add"}
      cancelText="Cancel"
      confirmLoading={confirmLoading}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="parameter"
          label="Parameter"
          rules={[{ required: true, message: "Please select parameter" }]}
        >
          <Input placeholder="Parameter" />
        </Form.Item>
        <Form.Item
          name="value"
          label="Value"
          rules={[{ required: true, message: "Please select value" }]}
        >
          <Input placeholder="Value" />
        </Form.Item>
        <Form.Item name="is_header" label="" valuePropName="checked">
          <Checkbox>
            <span>Is Header</span>
          </Checkbox>
        </Form.Item>
      </Form>
    </CommonModal>
  );
};

export default SMSConfigurationAddModal;
